import shuffle from 'lodash/shuffle';
import {Component} from 'react';

import Demyan from 'src/Assets/Images/Team/demyan.jpg?width=600&quality=85&ignore';
import Dima from 'src/Assets/Images/Team/dima.jpg?width=600&quality=85&ignore';
import Igor from 'src/Assets/Images/Team/igor.jpg?width=600&quality=85&ignore';
import Margarita from 'src/Assets/Images/Team/margarita.jpg?width=600&quality=85&ignore';
import Vlad from 'src/Assets/Images/Team/vlad.jpg?width=600&quality=85&ignore';
import BroadtechHorizon from 'src/Components/Home/BroadtechHorizon/BroadtechHorizon';
import BusinessBlock from 'src/Components/Home/Business/BusinessBlock';
import ContactUs from 'src/Components/Home/ContactUs/ContactUs';
import GroupOnDesktop from 'src/Components/Home/ContrastSection/GroupOnDesktop';
import GroupOnMobile from 'src/Components/Home/ContrastSection/GroupOnMobile';
import Expectations from 'src/Components/Home/Expectations/Expectations';
import InteractionsBlock from 'src/Components/Home/Interactions/InteractionsBlock';
import PerformanceBlock from 'src/Components/Home/Performance/PerformanceBlock';
import StartupsBlock from 'src/Components/Home/Startups/StartupsBlock';
import TeamBlock from 'src/Components/Home/Team/TeamBlock';
import {EnumHomePageAnchors} from 'src/Routes/EnumHomePageAnchors';
import {ITeamMember} from 'src/Routes/Pages/MainPage';

const teamMembers: ITeamMember[] = [
	{name: 'vlad', position: 'front-end-dev', photo: Vlad},
	{name: 'margarita', position: 'qa', photo: Margarita},
	{name: 'demyan', position: 'front-end-lead', photo: Demyan},
	{name: 'dima', position: 'web-dev', photo: Dima},
	{name: 'igor', position: 'pm', photo: Igor},
];

class LazyLoadedBlocks extends Component<any, any> {
	render() {
		return (
			<>
				<GroupOnMobile>
					<TeamBlock teamMembers={shuffle(teamMembers)} anchor={EnumHomePageAnchors.TEAM} />
					<BroadtechHorizon anchor={EnumHomePageAnchors.BROADTECH} />
					<Expectations anchor={EnumHomePageAnchors.HIT} />
				</GroupOnMobile>
				<GroupOnDesktop>
					<StartupsBlock anchor={EnumHomePageAnchors.STARTUP} />
					<BusinessBlock anchor={EnumHomePageAnchors.BUSINESS} />
					<PerformanceBlock anchor={EnumHomePageAnchors.PERFORMANCE} />
				</GroupOnDesktop>
				<InteractionsBlock anchor={EnumHomePageAnchors.INTERACTION} />
				<ContactUs />
			</>
		);
	}
}

export default LazyLoadedBlocks;
